import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import {
  Button,
} from "react-bootstrap";
import Confirmation from "CommonComponents/confirmation";
import store from "CommonState/store";
import {
  getPBPLink,
} from "Apis/massnahme-api";
import _ from "lodash";

@store("user")
@withLocation
export default class AntragAnpassenInfoPopup extends Component {
  openPBPLink(m) {
    const { user, onConfirm } = this.props;
    const link = getPBPLink(m, user);
    if (link) {
      window.open(link);
      onConfirm && onConfirm(); // Nach dem Click auf den Buuton Popup schließen und Antragsliste zeigen
    }
  }

  render() {
    const { onConfirm, antrag } = this.props;

    return (
      <Confirmation
        header='Antrag muss geändert werden'
        action='Schließen'
        actionStyle='primary'
        onConfirm={onConfirm}
      >
        <p>Der Statuswechsel gibt an, dass die zugrundliegende Maßnahme in PBP angepasst werden muss.</p>
        <p>Bitte erfassen Sie den Änderungsvorschlag zu der Maßnahme in PBP.</p>
        <p>{_.map(antrag.massnahmen, m => <>
          <Button variant='outline-primary' onClick={() => this.openPBPLink(m)}>Maßnahme PBP-{m.m_pbpid} in PBP anzeigen</Button>
          <br />
        </>)} </p>
        <br />
      </Confirmation>
    );
  }
}

export class AntragAnpassenPopup extends Component {
  render() {
    const { onCancel, onConfirm } = this.props;
    return (
      <Confirmation
        header='Anpassung bestätigen'
        action='Anpassung bestätigen'
        actionStyle='danger'
        onCancel={onCancel}
        onConfirm={onConfirm}
      >
        <p>Sind Sie sicher, dass die zugrundeliegende(n) Maßnahme(n) angepasst werden müssen?</p>
        <p>Wenn Sie dies bestätigen, müssen die entsprechenden Änderungen in PBP vorgenommen werden.</p>

      </Confirmation>
    );
  }
}
